<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'"
          >{{ aLang.c_create }} {{ title }}</span
        >
        <span v-if="mData.viewMode == 'update'"
          >{{ aLang.c_update }} {{ title }}</span
        >
        <span v-if="mData.viewMode == 'detail'"
          >{{ aLang.c_detail }} {{ title }}</span
        >
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="4">
              <el-form-item label="Merchant Code" prop="merchantCode">
                <el-input
                  type="text"
                  v-model="mData.dataForm.merchantCode"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Client Code" prop="clientCode">
                <el-input
                  type="text"
                  v-model="mData.dataForm.clientCode"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="SecureKey" prop="secureKey">
                <el-input
                  type="text"
                  v-model="mData.dataForm.secureKey"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >
              {{ aLang.c_update }}
            </el-button>
            <el-button @click="fn_go()" type="info" plain>
              {{ aLang.c_back }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import mushroom from "../../../service/api/dulich-api";
import LienKetNganHangSHBModel from "./LienKetNganHangSHBModel";

export default {
  data() {
    return {
      title: "liên kết Ngân hàng SHB",
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "LienKetNganHangSHB",
        dataDefault: {},
        dataForm: MethodService.copyObject(LienKetNganHangSHBModel.dataForm),
        validForm: LienKetNganHangSHBModel.validForm,
      },
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (type == "update") {
            let data = {
              merchant: {
                merchantCode: this.mData.dataForm.merchantCode,
                clientCode: this.mData.dataForm.clientCode,
                secureKey: this.mData.dataForm.secureKey,
                enabled: true,
              },
            };
            data.id = this.$router.currentRoute.params.id;
            await mushroom.diem_den_an_toan.partialUpdateAsync(data);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await mushroom.diem_den_an_toan.findByIdAsync({ id: id });
      if (res.result && res.result.merchant) {
        this.mData.dataForm = res.result.merchant;
      }
      console.log("this.mData.dataForm", this.mData.dataForm);
      console.log("this.mData.validForm", this.mData.validForm);
    },
    async fn_initDataDefault() {},
  },
  created: function () {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function () {},
};
</script>
<style scoped>
h4 {
  margin-bottom: 0;
}
.card {
  height: 88vh;
  margin-bottom: 0;
}
::v-deep .el-card__header {
  padding: 10px 20px;
}
.d-flex {
  display: flex;
  justify-content: space-between;
}
::v-deep .el-upload-list__item {
  transition: none !important;
}
.drag-file {
  max-width: 430px;
  margin: 0 auto;
}
::v-deep .el-upload-list.el-upload-list--text {
  text-align: left;
}
::v-deep .el-upload__tip {
  font-style: italic;
}
</style>
